import React, { useEffect, useState } from 'react';
import { Images } from 'constants/Images';
import InputBox from 'components/comman/InputBox';
import 'stylesheets/modal.scss';
import Button from 'components/comman/button';
import { useForm } from "react-hook-form";
import { API } from 'API/API';
import { toast } from "react-toastify";
import ClipLoader from 'react-spinners/ClipLoader';
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup';
import { useAuthContext } from 'context/auth/AuthContext';

const mess = "This field is required."
const schema = yup.object({
    name: yup.string().required(mess)
})

const RenameProjectModal = ({ isSmall, ...props }) => {
    const { handleSubmit, control, setValue, getValues } = useForm({
        resolver: yupResolver(schema)
    });

    const [loader, setLoader] = useState(false);
    const { token } = useAuthContext();

    const onSubmitform = (data) => {
        if (props.onSave) {
            props.onSave(data.name);
            return;
        }
        
        if (props.rowID?._id) {
            const payload = {
                name: getValues('name').toLowerCase(),
                zipCode: props.rowID.zipCode // preserve existing zipCode
            }
            UpdateEditProject(payload, props.rowID._id)
        }
    }

    useEffect(() => {
        getModalDetails()
    }, [props.show, props.rowID]);

    const getModalDetails = () => {
        if (props.rowID?._id) {
            setValue('name', props.rowID.name)
        } else if (props.initialName) {
            setValue('name', props.initialName)
        } else {
            setValue('name', '')
        }
    }

    const UpdateEditProject = async (data, id) => {
        setLoader(true)
        try {
            let response = await API.UpdateSubmittal(data, id, token)
            if (response.success) {
                toast.success(response.message)
                props.clickTable()
                props.clickProject() // close the modal
            } else {
                toast.error(response.message)
            }
        } catch (error) {
            toast.error("Network Error")
        } finally {
            setLoader(false)
        }
    }

    return (
        <div className={`modal createProject renameProject ${isSmall ? 'small' : ''} ${props.show ? 'show' : ''}`}>
            <div className='modal-dialog'>
                <div className='modal-content'>
                    <div className='modal-header'>
                        <h2>Edit Project Name</h2>
                        <button type='button' onClick={props.clickProject || props.onClose} className='btn close'>
                            <img src={Images.icon.closeCircle1} alt="close" />
                        </button>
                    </div>
                    <div className='modal-body'>
                        <form onSubmit={handleSubmit(onSubmitform)} className='row'>
                            <InputBox name="name" control={control} label='Project Name' type='text' />
                            {
                                (props.loading !== undefined ? props.loading : loader) ?
                                    <div style={{ marginLeft: '50px', marginTop: '10px' }} >
                                        <ClipLoader />
                                    </div>
                                    :
                                    <div style={{ marginTop: '10px' }} className='submit'>
                                        <Button type='primary' value='Update Project' style={{ backgroundColor: '#0154A0' }} />
                                    </div>
                            }
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RenameProjectModal;
